<template>
    <Dashboard v-if="!hasDisplayId" />
    <NotFound v-else-if="responseMessage.displayExists === false" displayNotFound/>
    <div v-else class="main d-flex flex-column">
        <component 
            :is="setParallels" 
            :announcements="responseMessage.announcements"
            :refreshPeriod="responseMessage.refreshPeriod"
            :isConnected="isConnected"
            class="flex-grow-1"
        ></component>
        <Footer :serverTime="responseMessage.currentTime"></Footer>
    </div>
</template>

<script>
    import { uuid } from 'vue-uuid';
    import SockJS from "sockjs-client";
    import Stomp from "webstomp-client";
    import NotFound from "../../components/NotFound";
    import Dashboard from "../../components/Dashboard";
    import ServiceStatus from "../../components/ServiceStatus";
    import OneParallel from "./Parallels/OneParallel";
    import TwoParallels from "./Parallels/TwoParallels";
    import ThreeParallels from "./Parallels/ThreeParallels";
    import FourParallels from "./Parallels/FourParallels";
    import BasicFallback from "./Fallbacks/BasicFallback";
    import Footer from "../../components/Footer";
    import {config} from "../../config"

    export default {
        name: "DisplayManager",

        components: {
            Dashboard,
            ServiceStatus,
            NotFound,
            OneParallel,
            TwoParallels,
            ThreeParallels,
            FourParallels,
            BasicFallback,
            Footer
        },

        data() {
            return {
                connected: false,

                connectionId: undefined,

                requestMessage: {
                    displayId: undefined,
                    connectionId: undefined,
                },

                responseMessage: {
                    announcements: [],
                },

                confirmator: undefined
            }
        },

        created() {
            this.requestMessage.connectionId = uuid.v4();
            window.addEventListener('beforeunload', this.handler);
            this.requestMessage.displayId = parseInt(this.$route.query.id);
            this.connect();
            this.connector = setInterval(() => {
                // try reconnecting every minute when socket is not connected or reload if display does not exist
                !this.connected && this.connect();
                !this.responseMessage.displayExists && location.reload();
            }, 1000*60);
            window.addEventListener('beforeunload', () => this.confirmator.clearInterval());
        },

        computed: {
            baseUrl() {
                return window.location.protocol + '//' + window.location.host;
            },

            hasDisplayId() {
                return this.requestMessage.displayId !== undefined && this.requestMessage.displayId !== null && !isNaN(this.requestMessage.displayId);
            },

            isConnected() {
                return this.connected;
            },

            getMessageLength() {
                return this.responseMessage.announcements != null ? this.responseMessage.announcements.length : 0;
            },

            setParallels() {
                switch (this.getMessageLength) {
                    case 1:
                        return "OneParallel";
                    case 2:
                        return "TwoParallels";
                    case 3:
                        return "ThreeParallels";
                    case 4:
                        return "FourParallels";
                    default:
                        return "BasicFallback";
                }
            },

            shouldRefresh() {
                return this.responseMessage.toBeRefreshed;
            }
        },

        watch: {
            shouldRefresh: (newValue) => {
                newValue && location.reload();
            }
        },

        methods: {
            connect() {
                if (this.requestMessage.connectionId && this.hasDisplayId) {
                    this.socket = new SockJS(config.serverUrl + "socket");
                    this.stompClient = Stomp.over(this.socket);
                    this.stompClient.connect({},
                        frame => {
                            this.connected = true;
                            console.log(frame);
                            this.stompClient.subscribe(`/displays/announcements/${this.requestMessage.connectionId}`, message => {
                                this.setMessage(message.body);
                            });

                            if (this.stompClient && this.stompClient.connected) {
                                this.stompClient.send("/app/displays/request-announcements", JSON.stringify(this.requestMessage), {});
                            }

                            this.confirmator = setInterval(() => {
                                this.stompClient.send("/app/displays/confirm-connection", JSON.stringify(this.requestMessage), {});
                            }, 1000*60*5);
                        },
                        error => {
                            console.error('Socket connection error:', error);
                            this.connected && this.handler();  // disconect errored connection
                            console.info('Reconnecting websocket in 10 seconds.');
                            setTimeout(() => this.connect(), 10000);
                        },
                    );
                }
            },

            handler: function handler() {
                if (this.stompClient) {
                    this.stompClient.send("/app/displays/disconnect", JSON.stringify(this.requestMessage), {});
                    this.stompClient.disconnect(); 
                }
                this.connected = false;
                clearInterval(this.confirmator);
            },


            setMessage(msg) {
                if (JSON.stringify(this.responseMessage) !== JSON.stringify(JSON.parse(msg))) {
                    this.responseMessage = JSON.parse(msg);
                }
            }
        },
    }
</script>

<style scoped>
    .main {
        width: 100vw;
        height: 100vh;
    }
</style>